import * as angular from "angular";
import {IController, IQService, ITimeoutService} from "angular";
import * as _ from "lodash";
import {PlanningCommonService} from "../../services/planning-coomon-service.service";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {ResizeService} from "../../../commons/services/resize-service.service";
import {SplitService} from "../../../commons/services/split-service.service";

export class PlanningTimelineCtrl implements IController {

  isLoading: boolean;
  allRoutes: any;
  depots: any;
  draft: any;
  draftAnalysis: any;
  leftOvers: any;
  jobs: any;
  selectedLeftOverJobIds: any;
  selectedRouteId: any;
  highlightedActivity: any;
  from: any;
  to: any;
  canEdit: any;
  hiddenRouteIds: any;
  timelineEnabled: any;
  isGroupedRoutes: any;
  isDispatched: boolean;
  selectedJobIds: string[];
  visibleRouteIds: Set<string> | null = null;
  onToggleRoute: Function;
  onLockRouteChange: Function;
  onRouteInfoClick: Function;
  onSelectLeftOver: Function;
  onAddStopsToRoute: Function;
  onSelectOrUnselectAllLeftovers: Function;
  onRecalcRoute: Function;
  onDeleteRoute: Function;
  onDispatchRoute: Function;
  onToggleLockRoute: Function;
  onMoveActivity: Function;
  onZoomActivity: Function;
  onActivitySelection: Function;
  onActivityHover: Function;
  onRemoveActivityFromRoute: Function;
  // onActivityRightClick: '&',
  onShowJobInfo: Function;
  onToggleGroupedRoutes: Function;
  onExportDraft: Function;
  onApproveAndDispatchDraft: Function;
  onHiddenRouteIdsChange: Function;
  onChangeRouteResource: Function;


  public routes: any[];
  public paginationRoutes: any[]
  public limit: number;
  public offset: number;
  public visibleResourceAllocationSkills: any[];
  public stopsWarning: {};
  public isPricingEnabled: boolean;
  public routeOptions: any;
  public queryString: string;
  public hideLockedRoutes: boolean = false;
  public doFitTimeline: boolean;
  public depotsMap: any;

  private routesCopyRef: any;
  private inspectedStopIds: any[];
  private isMouseVerticalDown: boolean;


  /* @ngInject */
  constructor(private resizeService: ResizeService, private $log, private agentConstants, private $filter, private $q: IQService,
              private planningCommonService: PlanningCommonService, private planningConstants, private commonsDialogService: CommonsDialogService, private IAMPermissions,
              private $mdSelect, private $timeout: ITimeoutService, private commonsService: CommonsService) {
  }

  $onInit() {
    this.routes = [];
    this.paginationRoutes = [];
    this.limit = 12;
    this.offset = 0;
    this.visibleResourceAllocationSkills = this.agentConstants.skills || [];
    this.inspectedStopIds = [];
    this.stopsWarning = {}
    this.isMouseVerticalDown = false;
    this.isPricingEnabled = this.IAMPermissions.hasPermission('priceplan.list');

    if (this.allRoutes?.length) {
      const visibleRoutes = this.visibleRouteIds
        ? this.allRoutes.filter(route => this.visibleRouteIds.has(route.id))
        : this.allRoutes;

      this._setRoutes(visibleRoutes);
      this.updatePaginationRoutes(visibleRoutes);
    }

    // ctrl.timelineEnabled = _.isUndefined(ctrl.timelineEnabled) ? !!_.get(ctrl.routes, 'length') : ctrl.timelineEnabled;
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.allRoutes && !changes.allRoutes.isFirstChange()) {

      const currentRoutes = changes.allRoutes.currentValue,
        previousRoutes = changes.allRoutes.previousValue;

      const routesToAdd: any[] = _.differenceBy<any, any>(currentRoutes, previousRoutes, 'id');
      const routesToRemove: any[] = _.differenceBy<any, any>(previousRoutes, currentRoutes, 'id');
      const filteredOutRoutes: any[] = _.remove(routesToAdd, route => this.visibleRouteIds && !this.visibleRouteIds.has(route.id)); routesToRemove.push(...filteredOutRoutes);

      this._setRoutes(routesToAdd, routesToRemove);

      if (!_.get(previousRoutes, 'length')) {
        this.setPaginationRoutes();
      } else {
        this.updatePaginationRoutes(routesToAdd);
      }

    }
    if (changes.draftAnalysis) {
      this.stopsWarning = _.get(this.draftAnalysis, 'stopWarnings', []);
    }
    if (changes.timelineEnabled && !changes.timelineEnabled.isFirstChange()) {
      if (this.timelineEnabled) {
        this.fitTimeline();
      }
      this.resizeService.resize();
    }

    if (changes.depots) {
      this.depotsMap = _.keyBy(this.depots, (d) => {
        return d.id
      });
    }

    if (changes.selectedRouteId && !changes.selectedRouteId.isFirstChange()) {
      // if (this.selectedRouteId) {
      //   const selectedRouteIndexInDisplay = _.findIndex(this.paginationRoutes, (r) => {
      //     return r.id === this.selectedRouteId;
      //   })
      //   const isRouteDisplayed = selectedRouteIndexInDisplay > -1;
      //   const routeRef = !isRouteDisplayed ? _.find(this.routes, (r) => {
      //     return r.id === this.selectedRouteId;
      //   }) : angular.copy(this.paginationRoutes[selectedRouteIndexInDisplay]);
      //   const paginationRoutesCopy = angular.copy(this.paginationRoutes);
      //
      //   if (isRouteDisplayed) {
      //     paginationRoutesCopy.splice(selectedRouteIndexInDisplay, 1);
      //     this.paginationRoutes = angular.copy(paginationRoutesCopy);
      //   }
      //
      //   this.$timeout(0).then(() => {
      //     paginationRoutesCopy.unshift(routeRef);
      //     this.paginationRoutes = paginationRoutesCopy;
      //   })
      // }
    }

    if (changes.visibleRouteIds && !changes.visibleRouteIds.isFirstChange()) {
      this._filterRoutesByQueries();
    }
  }

  // ******************************
  //        Public methods
  // ******************************

  onRoutesSelectOpen() {
    this.routeOptions = angular.copy(this.allRoutes);
    return this.$q.all(undefined);
  }

  onRoutesSelectClose() {
    this.routeOptions = [];
  }

  isLeftOverSelected(job) {
    return _.includes(this.selectedLeftOverJobIds, job.id);
  }

  getAllDraggedLeftOverJobs(draggedJob) {
    const isDraggedSelected = this.isLeftOverSelected(draggedJob);
    return isDraggedSelected ?
      _.filter(this.leftOvers, (job) => {
        return _.includes(this.selectedLeftOverJobIds, job.id);
      }) : [draggedJob]
  }

  onToggleHideLockedRoutes() {
    this.hideLockedRoutes = !this.hideLockedRoutes;
    this._filterRoutesByQueries();
  }

  // onBackToAllRoutes() {
  //   this.visibleResourceAllocationSkills = [];
  //   this.queryString = undefined;
  //
  //   this.offset = 0;
  //   this.routes = angular.copy(this.allRoutes);
  //   this.setPaginationRoutes();
  // }

  onQueryChange(query) {
    this.queryString = query;
    this._filterRoutesByQueries();
  }

  onLeftOversScroll(scrollLeft) {
    const container = document.querySelector('div.left-overs-container');
    if (scrollLeft) {
      container.scrollLeft -= 500
    } else {
      container.scrollLeft += 500
    }
  }

  getVisibleRoutesText() {
    const routesLength = _.get(this.allRoutes, 'length', 0);
    return this.$filter('translate')('Routes Displayed') + ': ' + _.get(this.routes, 'length') + '/' + routesLength;
  }

  hideRouteSelect() {
    this.$mdSelect.hide();
  }

  onActivityRightClick(routeId, jobIds, stopIds, relations, $event) {
    let actions = this.planningConstants.activityActions;
    if (jobIds.length > 1) {
      actions = _.filter(actions, (a) => {
        return !_.isEqual(a.key, 'INFO');
      })
    }

    const routeRef = _.find(this.allRoutes, (r) => {
      return r.id === routeId;
    })

    if ((routeRef && routeRef.status === 'DISPATCHED') || (routeRef && routeRef.locked)) {
      actions = _.filter(actions, (a) => {
        return a.key !== 'REMOVE';
      })
    }

    this.commonsService.openActionPanel(actions, $event)
      .then((reason: any) => {

        if (_.isEqual(reason.key, 'INFO')) {
          this.onShowJobInfo({jobId: jobIds[0]});
        }

        if (relations.length && _.isEqual(reason.key, 'LINKED')) {
          this.inspectedStopIds = _.map(relations, 'id').concat(stopIds);
          // Another way without the relations array on activity
          // var inspectedStopIds = [];
          // _.forEach(stopIds, function(stopId) {
          //    var stopDependencies = ctrl.routesAnalysis.stopDependencies[stopId];
          //    if (stopDependencies) {
          //       inspectedStopIds.push(stopId);
          //       stopDependencies = _.map(stopDependencies, 'id');
          //       inspectedStopIds = inspectedStopIds.concat(stopDependencies);
          //    }
          // });
          // ctrl.inspectedStopIds = _.uniq(inspectedStopIds);
        }

        if (_.isEqual(reason.key, 'REMOVE')) {
          this.onRemoveActivityFromRoute({routeId: routeId, jobIds: jobIds});
        }
      })
      .catch((reason) => {
        this.$log.info('Action Panel Closed', reason);
      });
  }

  onInspectedStopIdsChange(ids) {
    this.inspectedStopIds = ids;
  }

  onRoutesChangeByRoutes(routes) {
    // if (routes && routes.length !== this.routes.length) {
    //   this.offset = 0;
    //   this.routes = angular.copy(this.allRoutes);
    // }
    this.offset = 0;
    this.routes = routes;
    this.setPaginationRoutes();
  }

  onPaginationChange(pageIndex) {
    this.offset = this.limit * (pageIndex - 1);
    this.setPaginationRoutes();
    this.fitTimeline();
  }

  onPaginationBrowse(isNext) {
    this.offset = isNext ? (this.offset + this.limit) : (this.offset - this.limit);
    this.setPaginationRoutes();
    this.fitTimeline();
  }

  isPaginationItemSelected(pageIndex) {
    return (this.offset / this.limit) === pageIndex;
  }

  onTimelineFit() {
    this.doFitTimeline = undefined;
  }

  onFiltersChange(skills, routes) {

    if (!_.isEqual(this.routes, routes)) {
      this.routes = routes;
      this.setPaginationRoutes();
    }

    if (!_.isEqual(this.visibleResourceAllocationSkills, skills)) {
      this.visibleResourceAllocationSkills = skills;
      this._filterRoutesByQueries();
    }

  }

  // ******************************
  //        Private methods
  // ******************************

  private _filterRoutesByQueries() {
    let routes = angular.copy(this.allRoutes);

    if (this.visibleRouteIds) {
      routes = _.filter(routes, (r) => {
        return this.visibleRouteIds.has(r.id);
      });
    }

    if (this.queryString) {
      const query = _.toLower(this.queryString)
      routes = _.filter(routes, (r) => {
        return _.includes(_.toLower(r), query) ||
          _.includes(_.toLower(_.get(r, 'resource.allocationName')), query) ||
          _.includes(_.toLower(_.get(r, 'resource.vehicleName')), query) ||
          _.includes(_.toLower(_.get(r, 'resource.agentName')), query) ||
          this.searchQueryInRouteActivities(r.activities, query);
      })
    }

    if (this.visibleResourceAllocationSkills?.length) {
      routes = _.filter(routes, (r) => {
        const routeAllocationSkills = _.get(r, 'resource.allocationSkills', []);
        return !_.isEmpty(_.intersection(this.visibleResourceAllocationSkills, routeAllocationSkills));
      })
    }

    if (this.hideLockedRoutes) {
      routes = _.filter(routes, (r) => {
        return !r.locked;
      })
    }

    this.onRoutesChangeByRoutes(routes);
  }

  private setAllRoutesColor() {
    _.forEach(this.allRoutes, (r) => {
      _.set(r, 'color', this.planningCommonService.getRouteColor(r));
    })
  }

  private updateRoutes(addRoutes, removeRoutes) {
    const routesCopy = angular.copy(this.routes);
    const removeRouteIds = _.map(removeRoutes, 'id');

    this.routes = _.chain(routesCopy)
      .filter((r) => {
        return !_.includes(removeRouteIds, r.id);
      })
      .map((filteredRoute) => {
        return _.find(this.allRoutes, (route) => {
          return route.id === filteredRoute.id;
        })
      })
      .concat(addRoutes)
      .value();

    if (this.visibleRouteIds) {
      this.routes = _.filter(this.routes, (r) => {
        return this.visibleRouteIds.has(r.id);
      });
    }

    //     .sortBy('resourceId')
  }


  private setPaginationRoutes() {
    this.paginationRoutes = _.filter(this.routes, (r, index) => {
      return index + 1 > this.offset && index + 1 <= this.offset + this.limit;
    });
  }

  private updatePaginationRoutes(routesToAdd) {
    const paginationRouteIds = _.map(this.paginationRoutes, 'id');
    this.paginationRoutes = _.filter(this.allRoutes, (r) => {
      return _.includes(paginationRouteIds, r.id);
    })

    if (routesToAdd && routesToAdd.length) {
      this.paginationRoutes = _.sortBy(this.paginationRoutes.concat(routesToAdd), 'resourceId');
    }
  }

  private fitTimeline() {
    this.doFitTimeline = true;
  }

  private searchQueryInRouteActivities(activities, query) {
    return !!_.find(activities, (a) => {
      return _.includes(_.toLower(JSON.stringify(a)), query);
    })
  }

  private _setRoutes(routesToAdd, routesToRemove?) {
    this.setAllRoutesColor();
    this.updateRoutes(routesToAdd, routesToRemove);
  }

  private isQueryBarcode(packages, query): boolean {
    return !!_.find(packages, (p) => {
      return _.includes(_.toLower(p.barcode), query);
    })
  }
}

angular
  .module('bringoz.admin.planning')
  .component('planningTimeline', {
    bindings: {
      isLoading: '<?',
      allRoutes: '<', // All draft routes
      depots: '<',
      draft: '<',
      draftAnalysis: '<?',
      leftOvers: '<',
      jobs: '<',
      selectedLeftOverJobIds: '<',
      selectedRouteId: '<?',
      highlightedActivity: '<',
      selectedJobIds: '<?',
      from: '<',
      to: '<',
      canEdit: '<',
      hiddenRouteIds: '<',
      timelineEnabled: '<',
      isGroupedRoutes: '<?',
      isDispatched: '<?',
      visibleRouteIds: '<?',
      onToggleRoute: '&',
      onLockRouteChange: '&',
      onRouteInfoClick: '&',
      onSelectLeftOver: '&',
      onAddStopsToRoute: '&',
      onSelectOrUnselectAllLeftovers: '&',
      onRecalcRoute: '&',
      onDeleteRoute: '&',
      onDispatchRoute: '&',
      onToggleLockRoute: '&',
      onMoveActivity: '&',
      onZoomActivity: '&',
      onActivitySelection: '&',
      onActivityHover: '&',
      onRemoveActivityFromRoute: '&',
      // onActivityRightClick: '&',
      onShowJobInfo: '&',
      onToggleGroupedRoutes: '&',
      onExportDraft: '&',
      onApproveAndDispatchDraft: '&',
      onHiddenRouteIdsChange: '&',
      onChangeRouteResource: '&'
    }
    ,
    template: require('./planning-timeline.html').default,
    controller: PlanningTimelineCtrl
  });
